<template>
    <div>
      <!-- <covid-dialog v-model="showCovidDialog" @close="showCovidDialog = !showCovidDialog"/> -->

      <!-- PARALLAX 1 -->
      <section>
        <v-carousel hide-delimiters>
          <v-carousel-item v-for="(item,i) in carousel_items" :key="i" :src="item.src">
            <v-layout column align-center justify-end class="white--text">
              <!-- <img src="" alt="Vuetify.js" height="300"> -->
              <!-- <h1 class="white--text mb-2 display-1 text-xs-center">{{$t("home.mainTitle")}}</h1> -->
              <!-- <div class="subheading mb-3 text-xs-center">{{$t("home.subTitle")}}</div> -->
              <v-btn class="success book-btn" dark large to="/booking">
                {{$t("home.bookNow")}}
              </v-btn>
            </v-layout>
          </v-carousel-item>
        </v-carousel>
        <!-- <v-parallax :src="getImageUrl('section.jpg')" height="600">
          <v-layout column align-center justify-center class="white--text">
            <img src="../assets/vuetify.png" alt="Vuetify.js" height="200">
            <h1 class="white--text mb-2 display-1 text-xs-center">{{$t("home.mainTitle")}}</h1>
            <div class="subheading mb-3 text-xs-center">{{$t("home.subTitle")}}</div>
            <v-btn class="blue lighten-2 mt-5" dark large to="/booking">
              {{$t("home.bookNow")}}
            </v-btn>
          </v-layout>
        </v-parallax> -->
      </section>

      <section style="max-height: 200px;">
        <v-container grid-list-xl>
          <v-layout row wrap justify-center>
              <span class="display-1">Prenota qui: miglior prezzo garantito</span>
              <iframe src="https://www.bed-and-breakfast.it/scripts/widget-richieste/widget_iframe.cfm?idbooking=27395&l=en&colore=ir_grigio_scuro_piatto&wl=1" 
                scrolling="no" 
                frameborder="0" 
                style="border: none; overflow: hidden; margin-top: 20px; width: 100%; height: 420px;" 
                allowtransparency="true" 
              >
          </iframe>
          </v-layout>
        </v-container>
      </section>

      <section>
        <v-container grid-list-lg>
          <v-layout row wrap align-center>
            <v-flex xs12 sm12 md6 lg6 class="text-xs-center">
              <a href="https://www.bed-and-breakfast.it/certificato_eccellenza.cfm?id=9934&tipo=bbsic&anno=2022&lngc=en" target="_blank" rel="nofollow" title="Certificate of excellence"><img src="https://www.bed-and-breakfast.it/img/widget/certificato_eccellenza-en.png" alt="Certificate of excellence" style="width:300px;max-width:100%;border:0;"></a>
            </v-flex>

            <v-flex xs12 sm12 md6 lg6 class="text-xs-center">
              <a href="http://www.topbnb.it" target="_blank" rel="nofollow"><img src="http://www.topbnb.it/img/banner/topbb-quadrato-3.png" style="border: 0; width: 250px;"></a>  
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <!-- INTRO -->
      <section>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12 text-xs-center class="py-5">
            <p class="main-intro">
              {{$t("home.intro")}}
            </p>
            <p class="sub-intro">
              {{$t("home.intro2")}}
            </p>
          </v-flex>
          <v-flex text-xs-center class="pb-3">
            <v-btn color="success" dark large to="/oblobb">{{$t("home.more")}}</v-btn>
          </v-flex>
        </v-layout>
      </section>

      <!-- ROOMS -->
      <section>
        <v-layout row wrap>
          <v-flex sm12 md6 lg6>
            <img :src="getImageUrl('img/ammiraglio/ammiraglio 5.jpeg')" alt="" width="100%" height="100%">
          </v-flex>
          <v-flex sm12 md6 lg6>
            <v-card class="elevation-0 transparent mt-5">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline text-xs-center">{{$t("home.rooms")}}</div>
              </v-card-title>
              <v-card-text>
                <p class="sub-intro pa-3">
                  {{$t("home.rooms_intro")}}
                </p>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn class="success mt-5" dark large to="/rooms">
                  {{$t("home.more")}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </section>

      <!-- SERVICES -->
      <section>
        <v-layout row wrap>
          <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
            <v-card class="elevation-0 transparent mt-5">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline text-xs-center mt-5">{{$t("home.services")}}</div>
              </v-card-title>
              <v-card-actions class="justify-center">
                <v-btn class="success mt-5" dark large to="/services">
                  {{$t("home.more")}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2>
            <img :src="getImageUrl('img/dettagli/dettaglio chiavi.jpeg')" alt="" width="100%" height="100%">
          </v-flex>
        </v-layout>
      </section>

            <!-- BOOKING AWARD -->
      <section>
        <v-layout row wrap style="background-color: #01387a;">
          <v-flex xs12 sm12 md12 lg12 text-xs-center class="py-5 obloblue--text">
            <img :src="getImageUrl('img/award_2020.png')" alt="" style="width: 22%">
          </v-flex>
        </v-layout>
      </section>

      <!-- A DAY IN OBLO -->
      <section>
        <v-layout row wrap class="amber lighten-1">
          <v-flex xs12 sm12 md12 lg12 text-xs-center class="py-5 obloblue--text">
            <p class="sub-intro pa-3">
              {{$t("home.daytobb_intro")}}
            </p>
          </v-flex>
          <v-flex text-xs-center class="pb-3">
            <v-btn color="success" dark large to="/daytobb">{{$t("home.more")}}</v-btn>
          </v-flex>
        </v-layout>
      </section>

      <!-- EXPERIENCE -->
      <section>
        <v-layout row wrap class="my-5" align-center>
          <v-flex xs12 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline">{{$t("home.fb_title")}}</h2>
              <span class="subheading">
                {{$t("home.fb_sub")}}
              </span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container >
              <v-layout row wrap align-center>
                <v-flex xs12 md4 lg4 class="pa-1">
                  <customer-fb :text="customers[0].text" :name="customers[0].name" />
                </v-flex>
                <v-flex xs12 md4 class="pa-1">
                  <v-card class="elevation-0 transparent">
                    <customer-fb :text="customers[1].text" :name="customers[1].name" />
                  </v-card>
                </v-flex>
                <v-flex xs12 md4 class="pa-1">
                  <v-card class="elevation-0 transparent">
                    <customer-fb :text="customers[2].text" :name="customers[2].name" />
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <!-- PARALLAX 2 -->
      <section>
        <v-parallax :src="getImageUrl('img/oblo/paesaggio 2_med.jpeg')" height="380">
          <v-layout column align-center justify-center>
            <div class="headline white--text mb-3 text-xs-center">{{$t("home.slogan")}}</div>
            <em>{{$t("home.sub_slogan")}}</em>
            <v-btn class="success mt-5" dark large to="/booking">
                {{$t("home.bookNow")}}
            </v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <!-- INFO -->
      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-5">
            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">{{$t("home.customer_10perc")}}</div>
                </v-card-title>
                <v-card-text style="text-align: justify;" >
                  {{$t("home.customer_10perc_details")}}
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4 offset-sm1>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">{{$t("home.contact")}}</div>
                </v-card-title>
                <v-card-text class="text-xs-center">
                  {{$t("home.contact_details")}}
                </v-card-text>
                <v-list class="transparent">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="obloblue--text text--lighten-2">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>+39 3490699160</v-list-tile-title>
                      <v-list-tile-title>+39 3460652050</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="obloblue--text text--lighten-2">place</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Piazza dei Martiri 3, 95131 Catania</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="obloblue--text text--lighten-2">email</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>info@oblobb.it</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <!-- MAP -->
      <section>
        <v-layout row align-center justify-center class="my-0">
          <oblo-map style="heigth: 350px; width: 2000px;"/>
        </v-layout>
      </section>
    </div>
</template>

<script>
import ObloMap from "../components/ObloMap.vue";
import CustomerFb from "../components/CustomerFb.vue";
import CovidDialog from "../components/Covid.vue";

export default {
  components: { ObloMap, CustomerFb, CovidDialog },
  name: "Home",
  data() {
    return {
      showCovidDialog: true,
      carousel_items: [
        { src: require('../assets/img/oblo/corridoio 1.jpeg' )},
        { src: require('../assets/img/oblo/corridoio 3.jpeg') },
        { src: require('../assets/img/oblo/paesaggio5.jpeg') },
        { src: require('../assets/img/oblo/paesaggio 4.jpeg') }
      ],
      customers: [
        {
          name: "Andrea",
          text: "Accoglienza dei proprietari calorosa, mi hanno dato tutti i consigli e le dritte possibili, letto comodissimo, posizione strategica e una veduta dalla finestra fantastica, mi piace molto l'arredo...",
          state: "Italia"
        },
        {
          name: "Abdulaziz",
          text: "One of the best B&B I have ever stayed in and that's because the hosts Antonella and Milo. They truly made me feel am staying with my family. They were very kind and cooperative couple.",
          state: "Arabia Saudita"
        },
        {
          name: "Patxi",
          text: "Un establecimiento recién estrenado, con las últimas tendencias en iluminación (colorterapia en la ducha, luces regulables, etc.,) limpieza impecable, ubicación perfecta junto al puerto con vistas...",
          state: "Spagna"
        },
      ]
    }
  },
  methods: {
    getImageUrl: function (image) {
      return require(`../assets/${image}`);
    }
  }
}
</script>

<style scoped>
  .main-intro{
    font-size: x-large;
    font-weight: 500;
  }

  .sub-intro{
    font-size: large;
    font-weight: 400;
  }

  .img-intro{
    max-height: 530px;
    max-width: 720px;
    object-fit: contain;
  }

  .book-btn{
    margin-top: 200px;
  }

  .map-content{
    height: 400px;
    width: auto;
  }
</style>